module.exports = __webpack_public_path__ + "static/media/car.90b7214a.svg";